/** Regex matching valid media IDs (12-char server-generated hex, 24-char MongoDB ObjectIds, 36-char UUIDs). */
export const MEDIA_ID_PATTERN = /^[a-f0-9-]{12,36}$/i;
